var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("img", {
    attrs: {
      src: "data:image/svg+xml;base64," + _vm.makeData(_vm.hash, _vm.size),
      width: _vm.size,
      height: _vm.size,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }